<div #blockBody class="external-match-page-header" class="{{ displayMode }}">
	<div class="match-page-loading" *ngIf="gamesLoading && !gamesError">
		<span>
			Loading<span class="animated-ellipsis"><span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></span>
		</span>
	</div>
	<div class="match-page-loading" *ngIf="gamesError">
		<span class="error-main">
			<span>
				We are having trouble loading {{ localisationService.localeTerm('match', '') }} data
			</span>
		</span>

		<span>
			Please
			<span class="retry-link"
				(click)="reloadSingleGame(configurationObject.matchID)">
				try again
			</span>
		</span>
	</div>
	<a class="link-ctr"
		[href]="(!gamesLoading && !gamesError) ? generalService.getMatchLink(match.MatchData.SIMatchID) : null"
	>
		<app-match-page-header
			[class]="displayMode"
			*ngIf="!gamesLoading && !gamesError"
			[match]="match"
			[homeScoreJustChanged]="homeScoreJustChanged"
			[awayScoreJustChanged]="awayScoreJustChanged"
			[gamesLoading]="gamesLoading"
			[gamesError]="gamesError"
			[convertRound]="convertRound"
			[liveSocketError]="liveSocketError"
			[liveSocketReconnect]="retrieveSingleGame"
		></app-match-page-header>
	</a>
</div>